<template>
  <div class="container">
    <div class="content-wrapper">
<!--      <div class="page-header">-->
<!--        <h1>关于我们</h1>-->
<!--        <div class="page-subtitle">了解智维驿的发展历程、服务理念和公司愿景</div>-->
<!--      </div>-->

      <!-- 公司介绍 -->
      <div class="card">
        <div class="card-body">
          <div class="intro-row">
            <div class="intro-col">
              <h2 class="company-name">智维驿</h2>
              <h4 class="company-subtitle">智能设备后市场服务数智化云平台</h4>
              <div class="intro-box">
                <div
                    v-for="paragraph in introParagraphs"
                    :key="paragraph.id"
                    class="intro-paragraph"
                >
                  <template v-if="paragraph.highlightBefore">
                    <strong :style="{ color: paragraph.highlightBefore.color }">{{
                        paragraph.highlightBefore.text
                      }}</strong>{{ paragraph.text }}
                  </template>
                  <template v-else>
                    {{ paragraph.text }}
                  </template>
                  <strong v-if="paragraph.highlight"
                          :style="{ color: paragraph.highlight.color }">{{ paragraph.highlight.text }}</strong>
                  <template v-if="paragraph.textAfter">{{ paragraph.textAfter }}</template>
                </div>
              </div>
              <div class="statistics-row">
                <div
                    v-for="stat in statistics"
                    :key="stat.id"
                    class="statistics-col"
                    :style="{
                    background: stat.bgGradient,
                    borderColor: stat.borderColor
                  }"
                >
                  <h3 :style="{ color: stat.color }">{{ stat.value }}</h3>
                  <div class="statistics-label">{{ stat.label }}</div>
                </div>
              </div>
            </div>
            <div class="intro-col">
              <div class="showcase-card">
                <div class="showcase-icon">
                  <svg viewBox="64 64 896 896" width="1em" height="1em" fill="currentColor">
                    <path
                        d="M868 160h-92v-40c0-4.4-3.6-8-8-8H256c-4.4 0-8 3.6-8 8v40h-92a44 44 0 00-44 44v148c0 81.7 60 149.6 138.2 162C265.7 630.2 359 721.7 476 734.5v105.2H280c-17.7 0-32 14.3-32 32V904c0 4.4 3.6 8 8 8h512c4.4 0 8-3.6 8-8v-32.3c0-17.7-14.3-32-32-32H548V734.5C665 721.7 758.3 630.2 773.8 514 852 501.6 912 433.7 912 352V204a44 44 0 00-44-44zM184 352V232h64v207.6a91.99 91.99 0 01-64-87.6zm520 128c0 49.1-19.1 95.4-53.9 130.1-34.8 34.8-81 53.9-130.1 53.9h-16c-49.1 0-95.4-19.1-130.1-53.9-34.8-34.8-53.9-81-53.9-130.1V184h384v296zm136-128c0 41-26.9 75.8-64 87.6V232h64v120z"></path>
                  </svg>
                </div>
                <div>
                  <h1 class="showcase-title">智维驿</h1>
                  <div class="showcase-subtitle">智能设备后市场服务数智化云平台</div>
                  <div class="showcase-badge">
                    <div>AI智慧服务 · 创新升级</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 愿景和使命 -->
      <div class="card">
        <div class="card-body">
          <div class="vision-mission-row">
            <div
                v-for="item in visionMission"
                :key="item.id"
                class="vision-mission-col"
                :style="{ background: item.gradient }"
            >
              <h3>{{ item.icon }} {{ item.title }}</h3>
              <div class="vision-mission-content">{{ item.content }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 发展历程 -->
      <div class="card">
        <div class="card-head">
          <div class="card-head-title">发展历程</div>
        </div>
        <div class="card-body">
          <div class="timeline-wrapper">
            <div class="timeline-line"></div>
            <div
                v-for="(item, index) in timeline"
                :key="item.id"
                :class="['timeline-item', index % 2 === 0 ? 'timeline-item-left' : 'timeline-item-right', { 'timeline-item-last': item.isLast }]"
            >
              <div class="timeline-item-dot"></div>
              <div class="timeline-item-content">
                <h4 class="timeline-title">{{ item.title }}</h4>
                <div class="timeline-description">{{ item.description }}</div>
                <span class="timeline-tag">{{ item.year }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 服务优势和联系我们 -->
      <div class="advantage-contact-row">
        <div class="advantage-col">
          <div class="card">
            <div class="card-head">
              <div class="card-head-title">服务优势</div>
            </div>
            <div class="card-body">
              <div class="advantage-grid">
                <div
                    v-for="advantage in advantages"
                    :key="advantage.id"
                    class="advantage-item"
                >
                  <div class="advantage-icon" :style="{ color: getIconColor(advantage.icon) }">
                    <svg v-if="advantage.icon === 'trophy'" viewBox="64 64 896 896" width="1em" height="1em"
                         fill="currentColor">
                      <path
                          d="M868 160h-92v-40c0-4.4-3.6-8-8-8H256c-4.4 0-8 3.6-8 8v40h-92a44 44 0 00-44 44v148c0 81.7 60 149.6 138.2 162C265.7 630.2 359 721.7 476 734.5v105.2H280c-17.7 0-32 14.3-32 32V904c0 4.4 3.6 8 8 8h512c4.4 0 8-3.6 8-8v-32.3c0-17.7-14.3-32-32-32H548V734.5C665 721.7 758.3 630.2 773.8 514 852 501.6 912 433.7 912 352V204a44 44 0 00-44-44zM184 352V232h64v207.6a91.99 91.99 0 01-64-87.6zm520 128c0 49.1-19.1 95.4-53.9 130.1-34.8 34.8-81 53.9-130.1 53.9h-16c-49.1 0-95.4-19.1-130.1-53.9-34.8-34.8-53.9-81-53.9-130.1V184h384v296zm136-128c0 41-26.9 75.8-64 87.6V232h64v120z"></path>
                    </svg>
                    <svg v-else-if="advantage.icon === 'team'" viewBox="64 64 896 896" width="1em" height="1em"
                         fill="currentColor">
                      <path
                          d="M824.2 699.9a301.55 301.55 0 00-86.4-60.4C783.1 602.8 812 546.8 812 484c0-110.8-92.4-201.7-203.2-200-109.1 1.7-197 90.6-197 200 0 62.8 29 118.8 74.2 155.5a300.95 300.95 0 00-86.4 60.4C345 754.6 314 826.8 312 903.8a8 8 0 008 8.2h56c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5A226.62 226.62 0 01612 684c60.9 0 118.2 23.7 161.3 66.8C814.5 792 838 846.3 840 904.3c.1 4.3 3.7 7.7 8 7.7h56a8 8 0 008-8.2c-2-77-33-149.2-87.8-203.9zM612 612c-34.2 0-66.4-13.3-90.5-37.5a126.86 126.86 0 01-37.5-91.8c.3-32.8 13.4-64.5 36.3-88 24-24.6 56.1-38.3 90.4-38.7 33.9-.3 66.8 12.9 91 36.6 24.8 24.3 38.4 56.8 38.4 91.4 0 34.2-13.3 66.3-37.5 90.5A127.3 127.3 0 01612 612zM361.5 510.4c-.9-8.7-1.4-17.5-1.4-26.4 0-15.9 1.5-31.4 4.3-46.5.7-3.6-1.2-7.3-4.5-8.8-13.6-6.1-26.1-14.5-36.9-25.1a127.54 127.54 0 01-38.7-95.4c.9-32.1 13.8-62.6 36.3-85.6 24.7-25.3 57.9-39.1 93.2-38.7 31.9.3 62.7 12.6 86 34.4 7.9 7.4 14.7 15.6 20.4 24.4 2 3.1 5.9 4.4 9.3 3.2 17.6-6.1 36.2-10.4 55.3-12.4 5.6-.6 8.8-6.6 6.3-11.6-32.5-64.3-98.9-108.7-175.7-109.9-110.9-1.7-203.3 89.2-203.3 199.9 0 62.8 28.9 118.8 74.2 155.5-31.8 14.7-61.1 35-86.5 60.4-54.8 54.7-85.8 126.9-87.8 204a8 8 0 008 8.2h56.1c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5 29.4-29.4 65.4-49.8 104.7-59.7 3.9-1 6.5-4.7 6-8.7z"></path>
                    </svg>
                    <svg v-else-if="advantage.icon === 'heart'" viewBox="64 64 896 896" width="1em" height="1em"
                         fill="currentColor">
                      <path
                          d="M923 283.6a260.04 260.04 0 00-56.9-82.8 264.4 264.4 0 00-84-55.5A265.34 265.34 0 00679.7 125c-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5a258.44 258.44 0 00-56.9 82.8c-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3.1-35.3-7-69.6-20.9-101.9zM512 814.8S156 586.7 156 385.5C156 283.6 240.3 201 344.3 201c73.1 0 136.5 40.8 167.7 100.4C543.2 241.8 606.6 201 679.7 201c104 0 188.3 82.6 188.3 184.5 0 201.2-356 429.3-356 429.3z"></path>
                    </svg>
                    <svg v-else-if="advantage.icon === 'global'" viewBox="64 64 896 896" width="1em" height="1em"
                         fill="currentColor">
                      <path
                          d="M854.4 800.9c.2-.3.5-.6.7-.9C920.6 722.1 960 621.7 960 512s-39.4-210.1-104.8-288c-.2-.3-.5-.5-.7-.8-1.1-1.3-2.1-2.5-3.2-3.7-.4-.5-.8-.9-1.2-1.4l-4.1-4.7-.1-.1c-1.5-1.7-3.1-3.4-4.6-5.1l-.1-.1c-3.2-3.4-6.4-6.8-9.7-10.1l-.1-.1-4.8-4.8-.3-.3c-1.5-1.5-3-2.9-4.5-4.3-.5-.5-1-1-1.6-1.5-1-1-2-1.9-3-2.8-.3-.3-.7-.6-1-1C736.4 109.2 629.5 64 512 64s-224.4 45.2-304.3 119.2c-.3.3-.7.6-1 1-1 .9-2 1.9-3 2.9-.5.5-1 1-1.6 1.5-1.5 1.4-3 2.9-4.5 4.3l-.3.3-4.8 4.8-.1.1c-3.3 3.3-6.5 6.7-9.7 10.1l-.1.1c-1.6 1.7-3.1 3.4-4.6 5.1l-.1.1c-1.4 1.5-2.8 3.1-4.1 4.7-.4.5-.8.9-1.2 1.4-1.1 1.2-2.1 2.5-3.2 3.7-.2.3-.5.5-.7.8C103.4 301.9 64 402.3 64 512s39.4 210.1 104.8 288c.2.3.5.6.7.9l3.1 3.7c.4.5.8.9 1.2 1.4l4.1 4.7c0 .1.1.1.1.2 1.5 1.7 3 3.4 4.6 5l.1.1c3.2 3.4 6.4 6.8 9.6 10.1l.1.1c1.6 1.6 3.1 3.2 4.7 4.7l.3.3c3.3 3.3 6.7 6.5 10.1 9.6 80.1 74 187 119.2 304.5 119.2s224.4-45.2 304.3-119.2a300 300 0 0010-9.6l.3-.3c1.6-1.6 3.2-3.1 4.7-4.7l.1-.1c3.3-3.3 6.5-6.7 9.6-10.1l.1-.1c1.5-1.7 3.1-3.3 4.6-5 0-.1.1-.1.1-.2 1.4-1.5 2.8-3.1 4.1-4.7.4-.5.8-.9 1.2-1.4a99 99 0 003.3-3.7zm4.1-142.6c-13.8 32.6-32 62.8-54.2 90.2a444.07 444.07 0 00-81.5-55.9c11.6-46.9 18.8-98.4 20.7-152.6H887c-3 40.9-12.6 80.6-28.5 118.3zM887 484H743.5c-1.9-54.2-9.1-105.7-20.7-152.6 29.3-15.6 56.6-34.4 81.5-55.9A373.86 373.86 0 01887 484zM658.3 165.5c39.7 16.8 75.8 40 107.6 69.2a394.72 394.72 0 01-59.4 41.8c-15.7-45-35.8-84.1-59.2-115.4 3.7 1.4 7.4 2.9 11 4.4zm-90.6 700.6c-9.2 7.2-18.4 12.7-27.7 16.4V697a389.1 389.1 0 01115.7 26.2c-8.3 24.6-17.9 47.3-29 67.8-17.4 32.4-37.8 58.3-59 75.1zm59-633.1c11 20.6 20.7 43.3 29 67.8A389.1 389.1 0 01540 327V141.6c9.2 3.7 18.5 9.1 27.7 16.4 21.2 16.7 41.6 42.6 59 75zM540 640.9V540h147.5c-1.6 44.2-7.1 87.1-16.3 127.8l-.3 1.2A445.02 445.02 0 00540 640.9zm0-156.9V383.1c45.8-2.8 89.8-12.5 130.9-28.1l.3 1.2c9.2 40.7 14.7 83.5 16.3 127.8H540zm-56 56v100.9c-45.8 2.8-89.8 12.5-130.9 28.1l-.3-1.2c-9.2-40.7-14.7-83.5-16.3-127.8H484zm-147.5-56c1.6-44.2 7.1-87.1 16.3-127.8l.3-1.2c41.1 15.6 85 25.3 130.9 28.1V484H336.5zM484 697v185.4c-9.2-3.7-18.5-9.1-27.7-16.4-21.2-16.7-41.7-42.7-59.1-75.1-11-20.6-20.7-43.3-29-67.8 37.2-14.6 75.9-23.3 115.8-26.1zm0-370a389.1 389.1 0 01-115.7-26.2c8.3-24.6 17.9-47.3 29-67.8 17.4-32.4 37.8-58.4 59.1-75.1 9.2-7.2 18.4-12.7 27.7-16.4V327zM365.7 165.5c3.7-1.5 7.3-3 11-4.4-23.4 31.3-43.5 70.4-59.2 115.4-21-12-40.9-26-59.4-41.8 31.8-29.2 67.9-52.4 107.6-69.2zM165.5 365.7c13.8-32.6 32-62.8 54.2-90.2 24.9 21.5 52.2 40.3 81.5 55.9-11.6 46.9-18.8 98.4-20.7 152.6H137c3-40.9 12.6-80.6 28.5-118.3zM137 540h143.5c1.9 54.2 9.1 105.7 20.7 152.6a444.07 444.07 0 00-81.5 55.9A373.86 373.86 0 01137 540zm228.7 318.5c-39.7-16.8-75.8-40-107.6-69.2 18.5-15.8 38.4-29.7 59.4-41.8 15.7 45 35.8 84.1 59.2 115.4-3.7-1.4-7.4-2.9-11-4.4zm292.6 0c-3.7 1.5-7.3 3-11 4.4 23.4-31.3 43.5-70.4 59.2-115.4 21 12 40.9 26 59.4 41.8a373.81 373.81 0 01-107.6 69.2z"></path>
                    </svg>
                  </div>
                  <div>
                    <h5 class="advantage-title">{{ advantage.title }}</h5>
                    <div class="advantage-description">{{ advantage.description }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="contact-col">
          <div class="card">
            <div class="card-head">
              <div class="card-head-title">联系我们</div>
            </div>
            <div class="card-body">
              <ul class="contact-list">
                <li
                    v-for="contact in contactInfo"
                    :key="contact.id"
                    class="contact-item"
                >
                  <div class="contact-avatar" :style="{ color: contact.color }">
                    <svg v-if="contact.icon === 'phone'" viewBox="64 64 896 896" width="1em" height="1em"
                         fill="currentColor">
                      <path
                          d="M877.1 238.7L770.6 132.3c-13-13-30.4-20.3-48.8-20.3s-35.8 7.2-48.8 20.3L558.3 246.8c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l89.6 89.7a405.46 405.46 0 01-86.4 127.3c-36.7 36.9-79.6 66-127.2 86.6l-89.6-89.7c-13-13-30.4-20.3-48.8-20.3a68.2 68.2 0 00-48.8 20.3L132.3 673c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l106.4 106.4c22.2 22.2 52.8 34.9 84.2 34.9 6.5 0 12.8-.5 19.2-1.6 132.4-21.8 263.8-92.3 369.9-198.3C818 606 888.4 474.6 910.4 342.1c6.3-37.6-6.3-76.3-33.3-103.4zm-37.6 91.5c-19.5 117.9-82.9 235.5-178.4 331s-213 158.9-330.9 178.4c-14.8 2.5-30-2.5-40.8-13.2L184.9 721.9 295.7 611l119.8 120 .9.9 21.6-8a481.29 481.29 0 00285.7-285.8l8-21.6-120.8-120.7 110.8-110.9 104.5 104.5c10.8 10.8 15.8 26 13.3 40.8z"></path>
                    </svg>
                    <svg v-else-if="contact.icon === 'mail'" viewBox="64 64 896 896" width="1em" height="1em"
                         fill="currentColor">
                      <path
                          d="M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 110.8V792H136V270.8l-27.6-21.5 39.3-50.5 42.8 33.3h643.1l42.8-33.3 39.3 50.5-27.7 21.5zM833.6 232L512 482 190.4 232l-42.8-33.3-39.3 50.5 27.6 21.5 341.6 265.6a55.99 55.99 0 0068.7 0L888 270.8l27.6-21.5-39.3-50.5-42.7 33.2z"></path>
                    </svg>
                    <svg v-else-if="contact.icon === 'environment'" viewBox="64 64 896 896" width="1em" height="1em"
                         fill="currentColor">
                      <path
                          d="M854.6 289.1a362.49 362.49 0 00-79.9-115.7 370.83 370.83 0 00-118.2-77.8C610.7 76.6 562.1 67 512 67c-50.1 0-98.7 9.6-144.5 28.5-44.3 18.3-84 44.5-118.2 77.8A363.6 363.6 0 00169.4 289c-19.5 45-29.4 92.8-29.4 142 0 70.6 16.9 140.9 50.1 208.7 26.7 54.5 64 107.6 111 158.1 80.3 86.2 164.5 138.9 188.4 153a43.9 43.9 0 0022.4 6.1c7.8 0 15.5-2 22.4-6.1 23.9-14.1 108.1-66.8 188.4-153 47-50.4 84.3-103.6 111-158.1C867.1 572 884 501.8 884 431.1c0-49.2-9.9-97-29.4-142zM512 880.2c-65.9-41.9-300-207.8-300-449.1 0-77.9 31.1-151.1 87.6-206.3C356.3 169.5 431.7 139 512 139s155.7 30.5 212.4 85.9C780.9 280 812 353.2 812 431.1c0 241.3-234.1 407.2-300 449.1zm0-617.2c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm79.2 255.2A111.6 111.6 0 01512 551c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 01400 439c0-29.9 11.7-58 32.8-79.2C454 338.6 482.1 327 512 327c29.9 0 58 11.6 79.2 32.8C612.4 381 624 409.1 624 439c0 29.9-11.6 58-32.8 79.2z"></path>
                    </svg>
                    <svg v-else-if="contact.icon === 'global'" viewBox="64 64 896 896" width="1em" height="1em"
                         fill="currentColor">
                      <path
                          d="M854.4 800.9c.2-.3.5-.6.7-.9C920.6 722.1 960 621.7 960 512s-39.4-210.1-104.8-288c-.2-.3-.5-.5-.7-.8-1.1-1.3-2.1-2.5-3.2-3.7-.4-.5-.8-.9-1.2-1.4l-4.1-4.7-.1-.1c-1.5-1.7-3.1-3.4-4.6-5.1l-.1-.1c-3.2-3.4-6.4-6.8-9.7-10.1l-.1-.1-4.8-4.8-.3-.3c-1.5-1.5-3-2.9-4.5-4.3-.5-.5-1-1-1.6-1.5-1-1-2-1.9-3-2.8-.3-.3-.7-.6-1-1C736.4 109.2 629.5 64 512 64s-224.4 45.2-304.3 119.2c-.3.3-.7.6-1 1-1 .9-2 1.9-3 2.9-.5.5-1 1-1.6 1.5-1.5 1.4-3 2.9-4.5 4.3l-.3.3-4.8 4.8-.1.1c-3.3 3.3-6.5 6.7-9.7 10.1l-.1.1c-1.6 1.7-3.1 3.4-4.6 5.1l-.1.1c-1.4 1.5-2.8 3.1-4.1 4.7-.4.5-.8.9-1.2 1.4-1.1 1.2-2.1 2.5-3.2 3.7-.2.3-.5.5-.7.8C103.4 301.9 64 402.3 64 512s39.4 210.1 104.8 288c.2.3.5.6.7.9l3.1 3.7c.4.5.8.9 1.2 1.4l4.1 4.7c0 .1.1.1.1.2 1.5 1.7 3 3.4 4.6 5l.1.1c3.2 3.4 6.4 6.8 9.6 10.1l.1.1c1.6 1.6 3.1 3.2 4.7 4.7l.3.3c3.3 3.3 6.7 6.5 10.1 9.6 80.1 74 187 119.2 304.5 119.2s224.4-45.2 304.3-119.2a300 300 0 0010-9.6l.3-.3c1.6-1.6 3.2-3.1 4.7-4.7l.1-.1c3.3-3.3 6.5-6.7 9.6-10.1l.1-.1c1.5-1.7 3.1-3.3 4.6-5 0-.1.1-.1.1-.2 1.4-1.5 2.8-3.1 4.1-4.7.4-.5.8-.9 1.2-1.4a99 99 0 003.3-3.7zm4.1-142.6c-13.8 32.6-32 62.8-54.2 90.2a444.07 444.07 0 00-81.5-55.9c11.6-46.9 18.8-98.4 20.7-152.6H887c-3 40.9-12.6 80.6-28.5 118.3zM887 484H743.5c-1.9-54.2-9.1-105.7-20.7-152.6 29.3-15.6 56.6-34.4 81.5-55.9A373.86 373.86 0 01887 484zM658.3 165.5c39.7 16.8 75.8 40 107.6 69.2a394.72 394.72 0 01-59.4 41.8c-15.7-45-35.8-84.1-59.2-115.4 3.7 1.4 7.4 2.9 11 4.4zm-90.6 700.6c-9.2 7.2-18.4 12.7-27.7 16.4V697a389.1 389.1 0 01115.7 26.2c-8.3 24.6-17.9 47.3-29 67.8-17.4 32.4-37.8 58.3-59 75.1zm59-633.1c11 20.6 20.7 43.3 29 67.8A389.1 389.1 0 01540 327V141.6c9.2 3.7 18.5 9.1 27.7 16.4 21.2 16.7 41.6 42.6 59 75zM540 640.9V540h147.5c-1.6 44.2-7.1 87.1-16.3 127.8l-.3 1.2A445.02 445.02 0 00540 640.9zm0-156.9V383.1c45.8-2.8 89.8-12.5 130.9-28.1l.3 1.2c9.2 40.7 14.7 83.5 16.3 127.8H540zm-56 56v100.9c-45.8 2.8-89.8 12.5-130.9 28.1l-.3-1.2c-9.2-40.7-14.7-83.5-16.3-127.8H484zm-147.5-56c1.6-44.2 7.1-87.1 16.3-127.8l.3-1.2c41.1 15.6 85 25.3 130.9 28.1V484H336.5zM484 697v185.4c-9.2-3.7-18.5-9.1-27.7-16.4-21.2-16.7-41.7-42.7-59.1-75.1-11-20.6-20.7-43.3-29-67.8 37.2-14.6 75.9-23.3 115.8-26.1zm0-370a389.1 389.1 0 01-115.7-26.2c8.3-24.6 17.9-47.3 29-67.8 17.4-32.4 37.8-58.4 59.1-75.1 9.2-7.2 18.4-12.7 27.7-16.4V327zM365.7 165.5c3.7-1.5 7.3-3 11-4.4-23.4 31.3-43.5 70.4-59.2 115.4-21-12-40.9-26-59.4-41.8 31.8-29.2 67.9-52.4 107.6-69.2zM165.5 365.7c13.8-32.6 32-62.8 54.2-90.2 24.9 21.5 52.2 40.3 81.5 55.9-11.6 46.9-18.8 98.4-20.7 152.6H137c3-40.9 12.6-80.6 28.5-118.3zM137 540h143.5c1.9 54.2 9.1 105.7 20.7 152.6a444.07 444.07 0 00-81.5 55.9A373.86 373.86 0 01137 540zm228.7 318.5c-39.7-16.8-75.8-40-107.6-69.2 18.5-15.8 38.4-29.7 59.4-41.8 15.7 45 35.8 84.1 59.2 115.4-3.7-1.4-7.4-2.9-11-4.4zm292.6 0c-3.7 1.5-7.3 3-11 4.4 23.4-31.3 43.5-70.4 59.2-115.4 21 12 40.9 26 59.4 41.8a373.81 373.81 0 01-107.6 69.2z"></path>
                    </svg>
                  </div>
                  <div class="contact-content">
                    <h4 class="contact-title">{{ contact.title }}</h4>
                    <div class="contact-value">{{ contact.value }}</div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.container {
  display: flex;
  padding-top: 12rem;
  background: #f5f6fa;
}

.content-wrapper {
  margin: auto;
  width: 60rem;
  padding: 1.5rem;
}

.page-header {
  text-align: center;
  margin-bottom: 2rem;
}

.page-header h1 {
  font-size: 2rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
  color: #333;
}

.page-subtitle {
  font-size: 1rem;
  color: #666;
}

.card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 2rem;
}

.card-head {
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #e8e8e8;
}

.card-head-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #333;
}

.card-body {
  padding: 1.5rem;
}

/* 公司介绍 */
.intro-row {
  display: flex;
  gap: 2rem;
}

.intro-col {
  flex: 1;
}

.company-name {
  font-size: 2rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
  color: #333;
}

.company-subtitle {
  font-size: 1rem;
  color: #666;
  margin: 0 0 1.5rem 0;
}

.intro-box {
  margin-bottom: 2rem;
}

.intro-paragraph {
  font-size: 0.9rem;
  color: #666;
  line-height: 1.8;
  margin-bottom: 1rem;
}

.statistics-row {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-top: 2rem;
}

.statistics-col {
  flex: 1;
  width: 7.5rem;
  padding: 1rem;
  border-radius: 8px;
  border: 1px solid;
  text-align: center;
}

.statistics-col h3 {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
}

.statistics-label {
  font-size: 0.875rem;
  color: #666;
}

.showcase-card {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 2rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  color: #fff;
}

.showcase-icon {
  font-size: 3rem;
  flex-shrink: 0;
}

.showcase-title {
  font-size: 1.75rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
}

.showcase-subtitle {
  font-size: 0.9rem;
  margin: 0 0 1rem 0;
  opacity: 0.9;
}

.showcase-badge {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  font-size: 0.875rem;
}

/* 愿景和使命 */
.vision-mission-row {
  display: flex;
  gap: 1.5rem;
}

.vision-mission-col {
  flex: 1;
  padding: 2rem;
  border-radius: 12px;
  color: #fff;
}

.vision-mission-col h3 {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0 0 1rem 0;
}

.vision-mission-content {
  font-size: 0.9rem;
  line-height: 1.8;
  opacity: 0.95;
}

/* 发展历程 */
.timeline-wrapper {
  position: relative;
  padding: 2rem 0;
}

.timeline-line {
  position: absolute;
  left: 50%;
  top: 0;
  bottom: 0;
  width: 2px;
  background: #e8e8e8;
  transform: translateX(-50%);
}

.timeline-item {
  position: relative;
  display: flex;
  align-items: center;
  margin-bottom: 3rem;
  height: 6.25rem;
}

.timeline-item-last {
  margin-bottom: 0;
}

.timeline-item-dot {
  position: absolute;
  left: 50%;
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  background: #1890ff;
  border: 3px solid #fff;
  box-shadow: 0 0 0 2px #e8e8e8;
  transform: translateX(-50%);
  z-index: 2;
  flex-shrink: 0;
}

.timeline-item-left {
  flex-direction: row;
}

.timeline-item-right {
  flex-direction: row-reverse;
}

.timeline-item-content {
  width: calc(50% - 2rem);
  padding: 1.25rem;
}

.timeline-item-left .timeline-item-content {
  margin-right: 2rem;
  text-align: right;
}

.timeline-item-right .timeline-item-content {
  margin-left: 2rem;
  text-align: left;
}

.timeline-title {
  font-size: 1.125rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
  color: #333;
}

.timeline-description {
  font-size: 0.875rem;
  color: #666;
  line-height: 1.6;
  margin-bottom: 0.5rem;
}

.timeline-tag {
  display: inline-block;
  padding: 0.125rem 0.5rem;
  background: #e6f7ff;
  color: #1890ff;
  border-radius: 4px;
  font-size: 0.75rem;
}

/* 服务优势和联系我们 */
.advantage-contact-row {
  display: flex;
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.advantage-col {
  flex: 0 0 66.666%;
}

.contact-col {
  flex: 0 0 33.333%;
}

.advantage-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}

.advantage-item {
  flex: 0 0 calc(50% - 0.5rem);
  display: flex;
  align-items: flex-start;
  padding: 1.25rem;
  background: linear-gradient(135deg, rgb(250, 250, 250) 0%, rgb(245, 245, 245) 100%);
  border-radius: 0.75rem;
  border: 1px solid rgb(240, 240, 240);
}

.advantage-icon {
  font-size: 2.25rem;
  margin-right: 1rem;
  margin-top: 0.25rem;
  flex-shrink: 0;
}

.advantage-title {
  font-size: 1rem;
  font-weight: 600;
  margin: 0 0 0.75rem 0;
  color: rgb(24, 144, 255);
}

.advantage-description {
  font-size: 0.875rem;
  color: rgb(102, 102, 102);
  line-height: 1.6;
  margin: 0;
}

.contact-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.contact-item {
  display: flex;
  align-items: flex-start;
  padding: 1rem 0;
  border-bottom: 1px solid #f0f0f0;
}

.contact-item:last-child {
  border-bottom: none;
}

.contact-avatar {
  font-size: 1.5rem;
  margin-right: 0.75rem;
  flex-shrink: 0;
  margin-top: 0.25rem;
}

.contact-content {
  flex: 1;
}

.contact-title {
  font-size: 0.875rem;
  font-weight: 600;
  margin: 0 0 0.25rem 0;
  color: #333;
}

.contact-value {
  font-size: 0.875rem;
  color: #666;
}

</style>

<script setup>
import {ref} from 'vue'

// 统计数据
const statistics = ref([
  {
    id: 1,
    value: '5000+',
    label: '专业工程师',
    color: '#1890ff',
    bgGradient: 'linear-gradient(135deg, rgb(240, 248, 255) 0%, rgb(230, 247, 255) 100%)',
    borderColor: 'rgb(230, 247, 255)'
  },
  {
    id: 2,
    value: '300+',
    label: '服务城市',
    color: '#52c41a',
    bgGradient: 'linear-gradient(135deg, rgb(246, 255, 237) 0%, rgb(240, 249, 255) 100%)',
    borderColor: 'rgb(240, 249, 255)'
  },
  {
    id: 3,
    value: '2000+',
    label: '服务用户',
    color: '#fa8c16',
    bgGradient: 'linear-gradient(135deg, rgb(255, 247, 230) 0%, rgb(255, 242, 232) 100%)',
    borderColor: 'rgb(255, 242, 232)'
  },
  {
    id: 4,
    value: '2023年',
    label: '成立时间',
    color: '#eb2f96',
    bgGradient: 'linear-gradient(135deg, rgb(255, 240, 246) 0%, rgb(249, 240, 255) 100%)',
    borderColor: 'rgb(249, 240, 255)'
  }
])

// 公司介绍段落
const introParagraphs = ref([
  {
    id: 1,
    text: '是慧众金匠运营的智能设备后市场服务云平台。作为一家新兴的后市场服务平台，我们',
    highlight: {text: '另辟蹊径', color: '#52c41a'},
    textAfter: '，专注于别人不愿做、难做好的智能设备基础服务领域。',
    highlightBefore: {text: '智维驿', color: '#1890ff'}
  },
  {
    id: 2,
    text: '我们的服务涵盖',
    highlight: {text: '金融设备、机器人、新能源设备、无人机及共享底盘', color: '#fa8c16'},
    textAfter: '等智能设备的维修、保养和售后服务。'
  },
  {
    id: 3,
    text: '通过创新的',
    highlight: {text: 'AI智慧服务模式', color: '#eb2f96'},
    textAfter: '，我们致力于为超千亿规模的智能设备后市场服务行业带来革命性升级，让每一台智能设备都能享受到专业、高效、贴心的服务体验。'
  }
])

// 愿景和使命
const visionMission = ref([
  {
    id: 1,
    type: 'vision',
    icon: '🎯',
    title: '公司愿景',
    content: '成为智能设备后市场服务数智化的行业领导者，通过AI智慧服务模式，为超千亿规模的智能设备后市场服务行业带来革命性升级，让每一台智能设备都能享受到专业、高效、贴心的服务体验，推动整个行业向智能化、标准化、专业化方向发展。',
    gradient: 'linear-gradient(135deg, rgb(24, 144, 255) 0%, rgb(114, 46, 209) 100%)'
  },
  {
    id: 2,
    type: 'mission',
    icon: '🚀',
    title: '公司使命',
    content: '另辟蹊径，专注别人不愿做、难做好的智能设备基础服务领域，通过创新的AI智慧服务模式，为金融设备、机器人、新能源设备、无人机及共享底盘等各类智能设备提供专业、可靠、高效的后市场服务，解决行业痛点，创造服务价值。',
    gradient: 'linear-gradient(135deg, rgb(82, 196, 26) 0%, rgb(19, 194, 194) 100%)'
  }
])

// 发展历程
const timeline = ref([
  {
    id: 1,
    title: '公司成立',
    description: '智维驿正式成立，开始专注于智能设备后市场服务，建立专业的服务团队和技术体系',
    year: '2023年',
    position: 'left'
  },
  {
    id: 2,
    title: '业务扩展',
    description: '服务范围扩展到金融设备、家庭智能设备和无人机维修领域，建立多领域专业服务能力',
    year: '2024年',
    position: 'right'
  },
  {
    id: 3,
    title: '技术升级',
    description: '引入AI智能诊断技术，建立智能化服务平台，显著提升服务效率和质量',
    year: '2025年',
    position: 'left'
  },
  {
    id: 4,
    title: '全国布局',
    description: '服务网络覆盖全国300+城市，服务用户突破50000+，成为行业领先企业',
    year: '2026年计划',
    position: 'right'
  },
  {
    id: 5,
    title: '创新发展',
    description: '推出IoT设备监控、区块链维修记录等创新服务，引领行业技术发展方向',
    year: '2027年计划',
    position: 'left',
    isLast: true
  }
])

// 服务优势
const advantages = ref([
  {
    id: 1,
    icon: 'trophy',
    title: 'AI智慧诊断',
    description: '采用先进的AI智能诊断技术，诊断准确率高达98.5%，大幅提升服务效率和质量，为客户提供精准、快速的故障诊断服务'
  },
  {
    id: 2,
    icon: 'team',
    title: '专业团队',
    description: '拥有5000+专业工程师团队，平均从业经验8年以上，覆盖金融设备、机器人、新能源设备、无人机等多个专业领域，确保服务质量'
  },
  {
    id: 3,
    icon: 'heart',
    title: '全时服务',
    description: '提供7×24小时全天候服务响应，质量保证，先行赔付机制，让客户享受无忧的服务体验'
  },
  {
    id: 4,
    icon: 'global',
    title: '创新升级',
    description: '通过AI智慧服务模式，为超千亿规模的智能设备后市场服务行业带来革命性升级，引领行业向智能化、标准化方向发展'
  }
])

// 联系信息
const contactInfo = ref([
  {
    id: 1,
    icon: 'phone',
    title: '服务热线',
    value: '4008768770',
    color: '#1890ff'
  },
  {
    id: 2,
    icon: 'mail',
    title: '邮箱地址',
    value: 'user@wisemoresystem.com.cn',
    color: '#52c41a'
  },
  {
    id: 3,
    icon: 'environment',
    title: '公司地址',
    value: '上海市金山区山通路900号2幢6层',
    color: '#fa8c16'
  },
  {
    id: 4,
    icon: 'global',
    title: '官方网站',
    value: 'www.wiseagent.com.cn',
    color: '#eb2f96'
  },
  {
    id: 5,
    icon: 'global',
    title: '服务时间',
    value: '7×24小时服务',
    color: '#722ed1'
  }
])

// 获取图标颜色
function getIconColor(icon) {
  const colorMap = {
    trophy: '#1890ff',
    team: '#1890ff',
    heart: '#1890ff',
    global: '#1890ff'
  }
  return colorMap[icon] || '#1890ff'
}
</script>
